import { configureStore } from '@reduxjs/toolkit';
import thunk from "redux-thunk";
import { reducers } from "../reducers";
const devtools = window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__()
export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
    devTools: devtools,
});

//subscribe
// store.subscribe(() => console.log(store.getState()));
